import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, MenuItem } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

function BusinessInfo() {
  const auth = sessionStorage.getItem("user");

  const [formState, setFormState] = useState({
    website: "",
    job_title: "",
    company_estimated_monthly_volume: "",
    company_avarage_ticket_size: ""
  });

  const ReadData = async () => {
    try {
      let values = {
        tab: 6,
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(
        `${baseUrl}/defaultBusinesSettingData`,
        values,
        config
      );
      setFormState(result.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let values = {
        website: formState.website,
        job_title: formState.job_title,
        company_estimated_monthly_volume: formState.company_estimated_monthly_volume,
        company_avarage_ticket_size: formState.company_avarage_ticket_size
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(
        `${baseUrl}/save_business_info`,
        values,
        config
      );
      if (result.status === 200) {
        alert(result.data.message);
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    ReadData();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Website/Processing URL"
          name="website"
          value={formState.website}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Nature of Business"
          name="job_title"
          value={formState.job_title}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          select
          fullWidth
          label="Estimated Monthly Volume per Market (in USD)"
          name="company_estimated_monthly_volume"
          value={formState.company_estimated_monthly_volume}
          variant="outlined"
          onChange={handleChange}
        >
            <MenuItem value={"1"}>Below 50,000</MenuItem>
            <MenuItem value={"2"}>50,001 - 100,000</MenuItem>
            <MenuItem value={"3"}>100,001 - 300,000</MenuItem>
            <MenuItem value={"4"}>300,001 - 500,000</MenuItem>
            <MenuItem value={"5"}>500,001 - 800,000</MenuItem>
            <MenuItem value={"6"}>800,001  and above</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Average Ticket Size (in USD)"
          name="company_avarage_ticket_size"
          value={formState.company_avarage_ticket_size}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          onClick={handleSave}
          variant="contained"
          color="success"
          size="medium"
          sx={{
            float: "inline-end",
          }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default BusinessInfo;
